import React, { createContext, useState, ReactNode } from "react";

export const OrderbookFiltersContext = createContext({
  visibility: "0",
  setVisibility: (visibility: string) => {},
});

export const OrderbookFiltersProvider = ({
  children,
}: {
  children: ReactNode;
}) => {
  const [visibility, setVisibility] = useState("0");

  return (
    <OrderbookFiltersContext.Provider value={{ visibility, setVisibility }}>
      {children}
    </OrderbookFiltersContext.Provider>
  );
};
